import Image from 'next/image';
import type { ComponentsArticleTwoColumnCta } from 'queries/graphql';

import { buildImgProps } from 'utils/media';

import MarkdownText from 'generic/MarkdownText';
import BulletList from 'generic/BulletList';
import StyledDiv from 'generic/StyledDiv';

import styles from './styles.module.sass';

export default function TwoColumnCta({
  sectionId,
  heading,
  description,
  leftImage,
  ctaHref,
  ctaCopy,
  bulletList,
  backgroundColor,
}: ComponentsArticleTwoColumnCta) {
  return (
    <StyledDiv
      id={sectionId}
      className={styles.twoColumnCta}
      backgroundColor={backgroundColor}
      data-cy="two-column-cta"
    >
      <div className={styles.container}>
        <div className={styles.left}>
          {leftImage && (
            <Image
              {...buildImgProps(leftImage)}
              alt={leftImage.alt}
              height={360}
              width={360}
              className={styles.thumbnail}
            />
          )}
        </div>

        <div className={styles.right}>
          {leftImage && (
            <Image
              {...buildImgProps(leftImage)}
              alt={leftImage.alt}
              height={360}
              width={360}
              className={styles.thumbnail}
            />
          )}
          <div>
            <div className={styles.heading}>{heading}</div>
            <MarkdownText className={styles.description} text={description} />
            {bulletList && <BulletList {...bulletList} />}
          </div>
          <a href={ctaHref} className={styles.cta}>
            {ctaCopy || 'Click Here'}
          </a>
        </div>
      </div>
    </StyledDiv>
  );
}
